<script setup lang="ts">
import { useLocalizationStore } from '@/stores/localization';

const localization = useLocalizationStore();
</script>

<template>
  <div class="loading-spinner">
    <div class="spinner"></div>
    <p>{{ localization.k('loading') || 'Loading...' }}</p>
  </div>
</template>

<style lang="less" scoped>
@import '@/assets/css/variables.less';

.loading-spinner {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: @z-modal;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: @spacing-sm;
  padding: @spacing-md @spacing-xl;
  background: rgba(255, 255, 255, 0.95);
  border-radius: @border-radius-lg;
  box-shadow: @shadow-lg;
}

.spinner {
  width: 24px;
  height: 24px;
  border: 3px solid @gray-200;
  border-top-color: @primary-color;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

p {
  color: @text-secondary;
  font-size: @font-size-base;
  margin: 0;
}
</style>

